import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-gray-700 text-sm leading-relaxed" data-id="element-26">
    <h3 className="text-lg font-bold text-navy" data-id="element-27">Política de Privacidad</h3>
    <p data-id="element-28">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h4 className="font-semibold text-navy" data-id="element-29">1. Información que Recopilamos</h4>
    <p data-id="element-30">
      Recopilamos información personal que usted nos proporciona directamente,
      como su nombre, dirección de correo electrónico y datos de pago al
      realizar una compra.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-31">2. Uso de la Información</h4>
    <p data-id="element-32">
      Utilizamos su información para procesar sus pedidos, enviarle el producto
      adquirido, comunicarnos con usted sobre su compra y mejorar nuestros
      servicios.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-33">3. Protección de Datos</h4>
    <p data-id="element-34">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      su información personal contra acceso no autorizado, alteración o
      destrucción.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-35">4. Cookies</h4>
    <p data-id="element-36">
      Nuestro sitio web utiliza cookies para mejorar su experiencia de
      navegación y analizar el tráfico del sitio. Puede configurar su navegador
      para rechazar cookies.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-37">5. Terceros</h4>
    <p data-id="element-38">
      No vendemos ni compartimos su información personal con terceros, excepto
      cuando sea necesario para procesar su pago o cumplir con obligaciones
      legales.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-39">6. Sus Derechos</h4>
    <p data-id="element-40">
      Usted tiene derecho a acceder, rectificar o eliminar su información
      personal en cualquier momento contactándonos directamente.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-gray-700 text-sm leading-relaxed" data-id="element-41">
    <h3 className="text-lg font-bold text-navy" data-id="element-42">Términos y Condiciones</h3>
    <p data-id="element-43">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h4 className="font-semibold text-navy" data-id="element-44">1. Aceptación de los Términos</h4>
    <p data-id="element-45">
      Al acceder y utilizar este sitio web y adquirir nuestros productos, usted
      acepta estar sujeto a estos términos y condiciones de uso.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-46">2. Naturaleza del Producto</h4>
    <p data-id="element-47">
      El Kit de Supervivencia: Despido/Renuncia es un producto digital de
      carácter informativo y educativo. No constituye asesoría legal
      profesional. Para situaciones legales específicas, consulte con un abogado
      licenciado.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-48">3. Propiedad Intelectual</h4>
    <p data-id="element-49">
      Todo el contenido del kit, incluyendo textos, plantillas y guías, está
      protegido por derechos de autor. Se otorga una licencia de uso personal e
      intransferible al comprador.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-50">4. Política de Reembolso</h4>
    <p data-id="element-51">
      Debido a la naturaleza digital del producto, una vez entregado el acceso,
      no se realizan reembolsos salvo en casos excepcionales evaluados
      individualmente.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-52">
      5. Limitación de Responsabilidad
    </h4>
    <p data-id="element-53">
      No nos hacemos responsables por los resultados obtenidos del uso del
      material proporcionado. Los resultados pueden variar según cada situación
      individual.
    </p>

    <h4 className="font-semibold text-navy" data-id="element-54">6. Modificaciones</h4>
    <p data-id="element-55">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Los cambios serán efectivos inmediatamente después de su
      publicación en el sitio.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy text-gray-400 py-8 px-6" data-id="element-56">
        <div className="max-w-4xl mx-auto text-center" data-id="element-57">
          <p className="text-sm mb-4" data-id="element-58">
            © {new Date().getFullYear()} Kit de Supervivencia:
            Despido/Renuncia. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 mb-4" data-id="element-59">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-400 hover:text-gold transition-colors underline underline-offset-2" data-id="element-60">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-400 hover:text-gold transition-colors underline underline-offset-2" data-id="element-61">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs" data-id="element-62">
            Este producto es informativo y educativo. No constituye asesoría
            legal profesional. Consulta con un abogado para situaciones
            específicas.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-63">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-64">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-65">
              <div className="flex items-center justify-between p-5 border-b border-gray-200" data-id="element-66">
                <h2 className="font-serif text-xl font-bold text-navy" data-id="element-67">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-navy transition-colors p-1" data-id="element-68">
                  <XIcon className="w-5 h-5" data-id="element-69" />
                </button>
              </div>
              <div className="p-5 overflow-y-auto max-h-[calc(80vh-70px)]" data-id="element-70">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}